import React,{ useRef,useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";


export default function Contacto()
{
    useEffect(() => emailjs.init("_6oD08Ax4xI1FFAyk"), []);
    const { t } = useTranslation();
    const [show,setShow] = useState(false);
    const nombre = useRef();
    const email = useRef();
    const telefono = useRef();
    const mensaje = useRef();

    const handleOnFocus = () => {
        setShow(false);
    };
    const handleSubmit = (event) => 
        {
            event.preventDefault();
            const serviceId = "service_v8v4bu4";
            const templateId = "template_1y9n98a";
            try {
                emailjs.send(serviceId, templateId, {
                    nombre: nombre.current.value,
                    email: email.current.value,
                    telefono:telefono.current.value,
                    mensaje:mensaje.current.value
                });
                nombre.current.value = "";
                email.current.value = "";
                telefono.current.value = "";
                mensaje.current.value = "";
                setShow(true);
              } catch (error) {
                console.log(error);
              } finally {
              }
        };

    return(
        <section className="page-section" id="contacto">
            <div className="container">
                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">{t('contacto_title')}</h2>
                <div className="row justify-content-center" style={{margin:'30px'}}>
                    <div className="col-lg-8 col-xl-7">
                        <form id="contactForm" onSubmit={handleSubmit}>
                            <div className="form-floating mb-3">
                                <input className="form-control" id="name" type="text" required ref={nombre} onFocus={handleOnFocus}/>
                                <label style={{color:'#000'}} for="name">{t('contacto_text1')}</label>
                            </div>
                            <div className="form-floating mb-3">
                                <input className="form-control" id="email" type="email" required ref={email} onFocus={handleOnFocus}/>
                                <label style={{color:'#000'}} for="email">{t('contacto_text2')}</label>
                            </div>
                            <div className="form-floating mb-3">
                                <input className="form-control" id="phone" type="tel" required ref={telefono} onFocus={handleOnFocus}/>
                                <label style={{color:'#000'}} for="phone">{t('contacto_text3')}</label>
                            </div>
                            <div className="form-floating mb-3">
                                <textarea className="form-control" required id="message" type="text" style={{height:'10rem'}} ref={mensaje} onFocus={handleOnFocus}></textarea>
                                <label style={{color:'#000'}} for="message">{t('contacto_text4')}</label>
                            </div>
                            {show && (<div className="text-center text-danger mb-3">{t('contacto_text5')}</div>)}
                            <button className="btn btn-primary btn-xl" id="submitButton" type="submit">{t('contacto_btn')}</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}